import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";

const Layout2 = () => {
  return (
    <Fragment>
     {/* <div className="d-flex flex-column flex-md-row" style={{ height: "100vh" }} id="layout"> */}
        {/* <div className="left d-none d-lg-block">
          <img
            style={{ width: "100%", height: "100%" }}
            src="https://cdn.pixabay.com/photo/2023/09/10/15/33/maple-8245249_1280.jpg"
            alt=""
          />
        </div> */}
        {/* <div className="right w-100"
          style={{
            display: "grid",
            placeContent: "center",
          }}
        > */}
            <Outlet/>
        {/* </div>
      </div> */}
    </Fragment>
  );
};

export default Layout2;
